import { requirePermission } from '@/utils/filter';
import { appStore } from '@/store';
import { OPERATION_PERMISSIONS } from '@/configs/enums/permissions';

/**
 * BiBi（AIアシスタント）にアクセス可能かどうか
 */
export const canAccessAiAssistant = (): boolean => {
  // 1. 機能が有効かチェック
  if (!appStore.appConfig.enable_matching_support_agent) {
    return false;
  }

  // 2. 権限チェック
  if (!requirePermission([OPERATION_PERMISSIONS.COMPANY_MATCHING_READ])) {
    return false;
  }

  return true;
};
